import { TempDocumentDetailResponseWithAny } from "../hooks/queries/useTempDocumentDetailQuery";

export const getCompanyTagFromTempDoc = (
  tempDocumentDetail: TempDocumentDetailResponseWithAny,
) => {
  return tempDocumentDetail.tags.find((tag) => tag.categoryName === "회사");
};

export const getPjTagFromTempDoc = (
  tempDocumentDetail: TempDocumentDetailResponseWithAny,
) => {
  return tempDocumentDetail.tags.find((tag) => tag.categoryName === "PJ");
};

export const getTopicTagFromTempDoc = (
  tempDocumentDetail: TempDocumentDetailResponseWithAny,
) => {
  return tempDocumentDetail.tags.filter(
    (tag) => tag.categoryName === "주제분류",
  );
};

export const getBuisnessTagFromTempDoc = (
  tempDocumentDetail: TempDocumentDetailResponseWithAny,
) => {
  return tempDocumentDetail.tags.find((tag) => tag.categoryName === "사업구분");
};
